/**
 * Gets locale formatted date including time zone information.
 * @param {string} dateString - The date string to format.
 * @returns {string} Date string formatted to local time with time zone info.
 */
export function getLocaleDateWithTimeZone(dateString: string): string {
  const date: Date = new Date(dateString)
  const localeDate: string = getLocaleDateString(date)
  const timeZone: string = getCurrentTimeZoneName(date)

  return `${localeDate} ${timeZone}`
}

/**
 * Gets locale formatted date .
 * @param {Date} date - The date to format.
 * @returns {string} Date string formatted to local time.
 */
export function getLocaleDateString(date: Date): string {
  return date.toLocaleString(navigator.language, {
    hour: 'numeric',
    minute: 'numeric',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}

/**
 * Gets current time zone name based on users locale settings.
 * @param {Date} date - The date to format.
 * @returns {string} Time zone name.
 */
export function getCurrentTimeZoneName(date: Date): string {
  const timeZoneParts: string[] = new Intl.DateTimeFormat(navigator.language, {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeZoneName: 'short',
  })
    .format(Date.now())
    .split(' ')

  let timeZoneInfo: string = ''
  if (timeZoneParts.length >= 2) {
    timeZoneInfo = timeZoneParts[1]
  }

  if (!timeZoneInfo) {
    return ''
  }

  return /\d$/.test(timeZoneInfo) ? `(${timeZoneInfo}hr)` : `(${timeZoneInfo})`
}
